import { CheckoutState } from '../state/initial-state';

const reducer: WtrReducer<CheckoutState> = state => ({
  ...state,
  waiting: true,
  partnerDiscountConfirmationModalIsShown: false, // James what has partnerDiscount to do with waiting?
});

export default reducer;
